var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"plang"}},[_c('h2',[_vm._v("Programming Languages")]),_c('Tile',{attrs:{"items":_vm.langs}}),_c('h4',[_vm._v("Learning")]),_c('Tile',{attrs:{"items":_vm.learning}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }